export default function About() {
  const highlights = [
    { icon: 'ri-ship-line', label: 'Exporter', value: 'Global Trade' },
    { icon: 'ri-map-pin-line', label: 'Location', value: 'Surat, Gujarat' },
    { icon: 'ri-time-line', label: 'Experience', value: '1 Year' },
    { icon: 'ri-shopping-cart-line', label: 'MOQ', value: '25 Ton' },
    { icon: 'ri-global-line', label: 'Target', value: 'Worldwide' }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About <strong className="text-teal-600">Mavani globle</strong>
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Mavani globle is a professional export business supplying <strong>rice, spices, and wheat</strong> to buyers worldwide. 
            Led by <strong>Tarang Mavani</strong>, we focus on bulk orders with export-quality packaging and timely delivery. 
            Our commitment is to build long-term trust with international buyers through consistent quality and reliable service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className={`${item.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-500 mb-1 text-center">
                {item.label}
              </h3>
              <p className="text-lg font-bold text-gray-900 text-center">
                {item.value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
